// Respondent name helpers:
// dedupe while preserving order and generate compact display/tooltip text.

export type RespondentsTexts = { displayText: string; tooltipText: string };

export const dedupePreserveOrder = (arr: string[]): string[] => {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const v of arr) {
    const s = String(v ?? '').trim();
    if (!s) continue;
    if (seen.has(s)) continue;
    seen.add(s);
    out.push(s);
  }
  return out;
};

export const buildRespondentsTexts = (
  respondentsFullNames: string[],
  maxVisible: number = 2
): RespondentsTexts => {
  const fullNames = dedupePreserveOrder(respondentsFullNames);
  const visibleNames = fullNames.slice(0, maxVisible);

  const displayText =
    fullNames.length === 0
      ? ''
      : fullNames.length > maxVisible
        ? `${visibleNames.join('、')}...`
        : visibleNames.join('、');

  const tooltipText = fullNames.join('、');

  return { displayText, tooltipText };
};
